import * as types from "../actions/actionTypes";
const initialState = {
    is_fetched:false,
    loading: true,
    data: [],
    fund: {},
    last_item: "",
    storeStatus: false
};

const Fund = (state = initialState, action) => {
    let data;
    switch (action.type) {
        case types.FUND_LIST_REQUEST:
            return {...state,loading: true};
        case types.FUND_LIST_SUCCESS:            
            return {...state, data: action.payLoad, loading: false, is_fetched: true};
        case types.FUND_LIST_FAILURE:
            return {...state,loading: false};

        case types.FUND_ALL_REQUEST:
            return {...state,loading: true};
        case types.FUND_ALL_SUCCESS:            
            return {...state, data: action.payLoad, loading: false, is_fetched: true};
        case types.FUND_ALL_FAILURE:
            return {...state,loading: false};

        case types.FUND_SHOW_REQUEST:
            return {...state, fund: {}, loading: true};
        case types.FUND_SHOW_SUCCESS:            
            return {...state, fund: action.payLoad, loading: false, is_fetched: true};
        case types.FUND_SHOW_FAILURE:
            return {...state,loading: false};

        case types.FUND_STORE_REQUEST:
            return {...state,loading: true};
        case types.FUND_STORE_SUCCESS:
            data = !action.payLoad.is_default ? state.data : state.data.map(item => ({...item, is_default: false}));
            data.push(action.payLoad);
            return {...state, data: data, last_item:action.payLoad, loading: false, storeStatus: true};
        case types.FUND_STORE_FAILURE:
            return {...state,loading: false, storeStatus: false};

        case types.FUND_UPDATE_REQUEST:
            return {...state,loading: true, storeStatus: false};
        case types.FUND_UPDATE_SUCCESS: 
            data = [];
            if(state.data.length) {
                data = state.data.map(item => (
                    item.id === Number(action.payLoad.id) ? 
                    action.payLoad : (action.payLoad.is_default ? {...item, is_default: false} : item))
                );
            }           
            return {...state, data: data, fund: action.payLoad, loading: false, is_fetched: true, storeStatus: true};
        case types.FUND_UPDATE_FAILURE:
            return {...state,loading: false, storeStatus: false};

        case types.FUND_SET_DEFAULT_REQUEST:
            return {...state, loading: false};
        case types.FUND_SET_DEFAULT_SUCCESS:
            data = state.data.map(item => 
                item.id === Number(action.payLoad.id) ?
                {...action.payLoad} :
                {...item, is_default: false}
                );

            return {...state, data: data, loading: false};
        case types.FUND_SET_DEFAULT_FAILURE:
            return {...state, loading: false};

        case types.FUND_REMOVE_REQUEST:
            return {...state, loading: true};
        case types.FUND_REMOVE_SUCCESS:
            data = state.data.filter(item => item.id !== Number(action.payLoad.id));
            return {...state, data: data, loading: false};
        case types.FUND_REMOVE_FAILURE:
            return {...state, loading: false};

        default:
            return state;
    }
};

export default Fund;
